import { lazy } from "react";

export const MyProofsPage = lazy(() =>
  import("./ui/my-proofs").then((module) => ({
    default: module.MyProofs,
  }))
);
